
<div class="container section-gap">
  <div class="progress-chart-container">
    <div class="row flex-lg-row flex-column">
      <div class="col-12 col-lg-6 mb-4 mb-lg-0" *ngIf="imagePosition == 'left' && this.includedTaxonomies?.length > 0">
        <kla-action-plan-progress-chart-donut-graph [data]="graphData"
          [attr.role]="config?.chartAltText ? 'img' : null"
          [attr.aria-label]="config?.chartAltText || null"
          [attr.aria-hidden]="config?.chartAltText ? null : 'true'"></kla-action-plan-progress-chart-donut-graph>
      </div>

      <div [class]="imagePosition == 'full-width' ? 'col-12' : 'col-12 col-lg-6'">
        <div class="content">
          <kla-title
            [lineConfig]="lineConfig"
            [config]="{
              title: config?.title,
              badges: config?.badges,
              header: config?.header,
              titleAlias: config?.title,
              description: config?.description
            }"
          ></kla-title>
        </div>
      </div>

      <div
        class="col-12 col-lg-6 mt-4 mt-lg-0"
        *ngIf="imagePosition == 'right' && this.includedTaxonomies?.length > 0"
      >
        <kla-action-plan-progress-chart-donut-graph [data]="graphData"
          [attr.role]="config?.chartAltText ? 'img' : null"
          [attr.aria-label]="config?.chartAltText || null"
          [attr.aria-hidden]="config?.chartAltText ? null : 'true'"></kla-action-plan-progress-chart-donut-graph>
      </div>
      <div class="col-12 mt-4 justify-content-center align-items-center" *ngIf="imagePosition == 'full-width' || this.includedTaxonomies?.length > 0">
        <kla-action-plan-progress-chart-donut-graph [data]="graphData"
          [attr.role]="config?.chartAltText ? 'img' : null"
          [attr.aria-label]="config?.chartAltText || null"
          [attr.aria-hidden]="config?.chartAltText ? null : 'true'"></kla-action-plan-progress-chart-donut-graph>
      </div>
    </div>
  </div>
</div>
